import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import LockerDetails from '@/components/page/LockerDetails';

class LockerDetailsPortal extends Component {
  render() {

    // Container ref
    let targetContainer = document.getElementById('react-locker-details-container');
    let username: string;
    let userId: string;
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    } else {
      userId = targetContainer.getAttribute('data-userId');
      username = targetContainer.getAttribute('data-username');
    }

    return ReactDOM.createPortal(
        <LockerDetails {...{username, userId}}/>, targetContainer
    );
  }
}

export default LockerDetailsPortal;